import React from 'react';
import { Card } from 'react-bootstrap';

export const RulesCard: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => (
  <Card bg="light">
    <Card.Body className="p-3 small">{children}</Card.Body>
  </Card>
);
